// 3rd party
import { flow, makeObservable, observable, action } from 'mobx';

// Bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// Models
import { Product, Quicklink, IProgramRelationship } from 'models';

// Sources
import { QuicklinkSource } from 'sources';

class QuicklinkStore extends Store {
  private readonly quicklinkSource: QuicklinkSource;

  public customQuicklink: Quicklink;
  public configuredQuicklinks: Quicklink[];

  public constructor(quicklinkSource: QuicklinkSource, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    this.quicklinkSource = quicklinkSource;

    makeObservable(this, {
      customQuicklink: observable,
      configuredQuicklinks: observable,
      fetchCustomQuicklink: flow,
      fetchConfiguredQuicklinks: flow,
      resetCustomQuicklink: action,
      resetConfiguredQuicklinks: action,
    });
  }

  public hydrate(data: SerializedData): void {
    delete data.quicklinkSource;

    Object.assign(this, data);
  }

  public *fetchCustomQuicklink(
    url: string,
    product: Product,
    program: IProgramRelationship,
  ): Generator<Promise<Quicklink>, void, Quicklink> {
    this.customQuicklink = yield this.quicklinkSource.getCustomQuicklink(this.logger, url, product, program);
  }

  public *fetchConfiguredQuicklinks(
    product: Product,
    program: IProgramRelationship,
  ): Generator<Promise<Quicklink[]>, void, Quicklink[]> {
    this.configuredQuicklinks = yield this.quicklinkSource.getConfiguredQuicklinks(this.logger, product, program);
  }

  public resetCustomQuicklink(): void {
    this.customQuicklink = null;
  }

  public resetConfiguredQuicklinks(): void {
    this.configuredQuicklinks = null;
  }
}

export { QuicklinkStore };
